import type { FC } from 'react'

import { cn } from '@/lib/utils'

type MarqueeProps = {
    text: string
    speed?: number
    repeat?: number
    className?: string
    itemClassName?: string
    separator?: boolean
}

/**
 * Infinite horizontal ticker. The track holds two identical halves and GSAP
 * translates it by exactly half its width, so the loop is seamless.
 */
export const Marquee: FC<MarqueeProps> = ({
    text,
    speed = 38,
    repeat = 6,
    className,
    itemClassName,
    separator = true
}) => {
    const items = Array.from({ length: repeat * 2 }, (_, i) => i)

    return (
        <div className={cn('w-full overflow-hidden', className)} aria-hidden='true'>
            <div className='marquee-track' data-marquee={speed}>
                {items.map((i) => (
                    <span key={i} className={cn('flex shrink-0 items-center whitespace-nowrap', itemClassName)}>
                        {text}
                        {separator && <span className='mx-6 inline-block opacity-40'>—</span>}
                        {!separator && <span className='mx-8 inline-block' />}
                    </span>
                ))}
            </div>
        </div>
    )
}
